import { App as AntApp, ConfigProvider, message, theme as antdTheme } from 'antd';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { useReferralCode } from './hooks/useReferralCode';
import { TECHNICAL_WORK_IN_PROGRESS } from './index';
import IndexPage from './pages/IndexPage';
import LoginPage from './pages/LoginPage';
import MaintenancePage from './pages/MaintenancePage';
import NotFoundPage from './pages/NotFoundPage';
import ProfilePage from './pages/ProfilePage';
import ReferralSettingsPage from './pages/ReferralSettingsPage';
import SettingsPage from './pages/SettingsPage';

// Configure global toast settings
message.config({ maxCount: 3, top: 8 });

function AppContent() {
  const { theme } = useTheme();

  // Handle referral code from URL parameter (runs on every page load)
  useReferralCode();

  return (
    <ConfigProvider
      theme={{
        algorithm: theme === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: {
          colorPrimary: '#1890ff',
        },
      }}
    >
      <AntApp>
        <AuthProvider>
          <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
            {TECHNICAL_WORK_IN_PROGRESS ? (
              <Routes>
                <Route path="*" element={<MaintenancePage />} />
              </Routes>
            ) : (
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route element={<ProtectedRoute />}>
                  <Route path="/" element={<IndexPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/referral" element={<ReferralSettingsPage />} />
                </Route>
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            )}
          </Router>
        </AuthProvider>
      </AntApp>
    </ConfigProvider>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
